const DEFAULT_ICE_GATHERING_TIMEOUT_MS = 5000

/**
 * Resolves once the peer connection has finished gathering ICE candidates, or after
 * a timeout (so a slow/blocked STUN never hangs the answer). Mirrors the telemed
 * Call.js helper; kept here so any server-recording client can reuse it.
 */
export function waitForIceGathering(pc, timeoutMs = DEFAULT_ICE_GATHERING_TIMEOUT_MS) {
  return new Promise((resolve) => {
    if (!pc || pc.iceGatheringState === 'complete') {
      resolve()
      return
    }
    let settled = false
    const done = () => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      pc.removeEventListener('icegatheringstatechange', check)
      resolve()
    }
    const check = () => {
      if (pc.iceGatheringState === 'complete') done()
    }
    const timer = setTimeout(done, timeoutMs)
    pc.addEventListener('icegatheringstatechange', check)
  })
}

export const __test__ = { DEFAULT_ICE_GATHERING_TIMEOUT_MS }
